<template>
  <content-view class="slide">
    <div class="bg-white pl32 pr32 pt32">
      <a-tabs @tabClick="tabClickCli">
        <a-tab-pane key="1" tab="网点">
          <div class="slide-balance">
            <h4 class="slide-title">
              {{ activeKey == "1" ? "网点列表" : "分拣中心列表" }}
            </h4>
          </div>
          <a-table
            v-if="activeKey == '1'"
            :columns="columns"
            :dataSource="sellList"
            bordered
            class="mt16"
            :pagination="pagination"
            :scroll="{ x: true }"
            :rowKey="
              (record, index) => {
                return index;
              }
            "
            @change="paginationChange"
          >
            <span slot="time" slot-scope="text, record">
              {{ record.service_day }} <br />
              {{ record.service_time.opening_am }} <br />
              {{ record.service_time.opening_pm }}
            </span>
            <span slot="status" slot-scope="text, record">
              {{ record.status == "1" ? "正常" : "禁用" }}
            </span>

            <span slot="action" slot-scope="text, record">
              <a
                class="btn btn_text"
                @click="monitoringCli(text)"
                :class="{ forbidden: !$route.meta.role.detail }"
                >监控</a
              >
            </span>
          </a-table>
        </a-tab-pane>
        <a-tab-pane key="2" tab="分拣中心">
          <div class="slide-balance">
            <h4 class="slide-title">
              {{ activeKey == "1" ? "网点列表" : "分拣中心列表" }}
            </h4>
          </div>
          <a-table
            :columns="columnsF"
            :dataSource="sellList"
            bordered
            class="mt16"
            :pagination="pagination"
            :scroll="{ x: true }"
            :rowKey="
              (record, index) => {
                return index;
              }
            "
            @change="paginationChange"
          >
            <span slot="status" slot-scope="text, record">
              {{ record.status == "1" ? "正常" : "禁用" }}
            </span>
            <span slot="action" slot-scope="text, record">
              <a
                class="btn btn_text"
                @click="monitoringCli(text)"
                :class="{ forbidden: !$route.meta.role.detail }"
                >监控</a
              >
            </span>
          </a-table>
        </a-tab-pane>
      </a-tabs>
      <Monitoring
        :DialogFlg="DialogFlg"
        :eq_code="eq_code"
        :eq_token="eq_token"
        :eq_channeln="eq_channeln"
        @xiaoshi="MonitoringValue"
      />
    </div>
  </content-view>
</template>

<script>
import Monitoring from "./Dialog/index.vue";
export default {
  name: "businessSlide",
  data() {
    return {
      DialogFlg: false,
      eq_token: "",
      eq_code: "",
      eq_channeln:1,
      activeKey: "1",
      form: {},
      bannerNumList: [
        {
          id: 1,
          name: "1",
        },
        {
          id: 2,
          name: "2",
        },
        {
          id: 3,
          name: "3",
        },
        {
          id: 4,
          name: "4",
        },
        {
          id: 5,
          name: "5",
        },
        {
          id: 6,
          name: "6",
        },
      ],
      columns: [
        {
          title: "序号",
          customRender: (text, record, index) => `${index + 1}`,
          width: 70,
        },
        {
          title: "网点名称",
          dataIndex: "name",
          width: 200,
        },
        {
          title: "地址",
          dataIndex: "address",
          width: 150,
        },
        {
          title: "管家工作时间",
          dataIndex: "",
          scopedSlots: { customRender: "time" },
          width: 150,
        },
        {
          title: "网点状态",
          scopedSlots: { customRender: "status" },
          width: 150,
        },
        // {
        //   title: "网点用户数",
        //   dataIndex: "num",
        //   width: 150,
        // },
        {
          title: "操作",
          dataIndex: "",
          scopedSlots: { customRender: "action" },
          width: 160,
        },
      ],
      columnsF: [
        {
          title: "序号",
          customRender: (text, record, index) => `${index + 1}`,
          width: 70,
        },
        {
          title: "分拣中心名称",
          dataIndex: "name",
          width: 200,
        },
        {
          title: "分拣中心地址",
          dataIndex: "address",
          width: 150,
        },
        {
          title: "分拣中心状态",
          scopedSlots: { customRender: "status" },
          width: 150,
        },
        {
          title: "操作",
          dataIndex: "",
          scopedSlots: { customRender: "action" },
          width: 160,
        },
      ],
      sellList: [
        {
          service_time: {
            opening_am: "上午03:00-04:00",
            opening_pm: "下午23:02-23:15",
          },
        },
      ],

      parentList: [],
      brokeList: [],
      page: 1,
      limit: 10,
      pagination: {
        //默认当前页
        defaultCurrent: 1,
        defaultPageSize: 10,
        showTotal() {
          return `共 ${this.total} 条数据`;
        },
        showSizeChanger: true,
        total: 0,
      },
      radioValue: "0",
    };
  },
  components: {
    Monitoring,
  },
  methods: {
    // 监控
    monitoringCli(row) {
      this.DialogFlg = true;
      this.eq_token = row.eq_token;
      this.eq_code = row.eq_code;
      this.eq_channeln = row.eq_channeln
    },
    MonitoringValue(val) {
      this.DialogFlg = val;
    },
    tabClickCli(val) {
      this.activeKey = val;
      (this.sellList = [
        {
          service_time: {
            opening_am: "上午03:00-04:00",
            opening_pm: "下午23:02-23:15",
          },
        },
      ]),
        this.getList();
    },
    // 头部数据重置
    reset() {
      this.page = 1;
      this.limit = 10;
      this.$set(this.pagination, "current", 1);
      this.$set(this.pagination, "pageSize", 10);
      this.$refs.pa.reset();
      this.getList();
    },
    //查询
    search() {
      this.$set(this.pagination, "current", 1);
      this.$set(this.pagination, "pageSize", 10);
      this.page = 1;
      this.limit = 10;
      this.getList(true);
    },
    /**
     * 分页变化回调
     * @param pagination 当前分页器信息
     */
    paginationChange(pagination) {
      this.$set(this.pagination, "current", pagination.current);
      this.$set(this.pagination, "pageSize", pagination.pageSize);
      this.page = pagination.current;
      this.limit = pagination.pageSize;
      this.getList();
    },
    getList(status = false) {
      let date = this.form.orderTime;
      if (date && date.length > 0) {
        this.form.ctime_s = parseInt(
          this.$moment(date[0]).hour(0).minute(0).second(0).valueOf() / 1000
        );
        this.form.ctime_e = parseInt(
          this.$moment(date[1]).hour(23).minute(59).second(59).valueOf() / 1000
        );
      } else {
        delete this.form.ctime_s;
        delete this.form.ctime_e;
      }
      this.form.page = this.page;
      this.form.limit = this.limit;
      this.form.type = this.activeKey;

      this.$api.account.blockList(this.form).then((res) => {
        this.sellList = res.data.list;
        this.pagination.total = res.total * 1;
        status
          ? this.$message.success("共查询到" + res.total + "条信息")
          : "";
      });
    },
    parentChange(val) {
      this.getBroke(val);
    },
  },
  mounted() {
    this.getList();
  },
  watch: {
    $route(val, oldVal) {
      if (val.name === "stockdetail") {
        this.page = 1;
        this.limit = 10;
        this.$set(this.pagination, "current", 1);
        this.$set(this.pagination, "pageSize", 10);
        this.getList();
      }
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss">
.slide {
  &-balance {
    display: flex;
    justify-content: space-between;
  }
  &-title {
    color: $title-color-black-85;
    @include pxAndLh(16);
    font-weight: bold;
  }
  .image {
    height: 64px;
  }
}
</style>
